<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="60px"
    height="60px"
    viewBox="0 0 60 60"
    version="1.1"
  >
    <defs>
      <radialGradient
        id="radial0"
        gradientUnits="userSpaceOnUse"
        cx="0"
        cy="0"
        fx="0"
        fy="0"
        r="1"
        gradientTransform="matrix(0.000000000000001837,30,-30,0.000000000000001837,30,30)"
      >
        <stop
          offset="0.938156"
          style="stop-color: rgb(16.078431%, 36.862745%, 100%); stop-opacity: 1"
        />
        <stop
          offset="1"
          style="stop-color: rgb(6.666667%, 22.745098%, 79.215686%); stop-opacity: 0"
        />
      </radialGradient>
    </defs>
    <g>
      <path
        style="stroke: none; fill-rule: nonzero; fill: url(#radial0)"
        d="M 60 30 C 60 24.066406 58.242188 18.265625 54.945312 13.332031 C 51.648438 8.398438 46.960938 4.554688 41.480469 2.285156 C 36 0.0117188 29.964844 -0.582031 24.148438 0.578125 C 18.328125 1.734375 12.980469 4.589844 8.785156 8.785156 C 4.589844 12.980469 1.734375 18.328125 0.578125 24.148438 C -0.582031 29.964844 0.0117188 36 2.285156 41.480469 C 4.554688 46.960938 8.398438 51.648438 13.332031 54.945312 C 18.265625 58.242188 24.066406 60 30 60 L 30 53.304688 C 25.390625 53.304688 20.882812 51.9375 17.050781 49.378906 C 13.21875 46.816406 10.230469 43.175781 8.46875 38.917969 C 6.703125 34.660156 6.242188 29.972656 7.140625 25.453125 C 8.039062 20.933594 10.261719 16.78125 13.519531 13.519531 C 16.78125 10.261719 20.933594 8.039062 25.453125 7.140625 C 29.972656 6.242188 34.660156 6.703125 38.917969 8.46875 C 43.175781 10.230469 46.816406 13.21875 49.378906 17.050781 C 51.9375 20.882812 53.304688 25.390625 53.304688 30 Z M 60 30 "
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
